
import { deleteLabelValueAction } from '~src/catalog/actions/labelValues/DeleteLabelValueAction';
import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { Messages } from '../../../codegen/Localize';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const DeleteLabelValueEntityAction: IEntityAction<ILabelValueInfo, {}> = {
  name: EntityActionNames.Delete,
  translateName: Messages.delete_action,
  isVisible: (targetItems, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.labelManagementEnabled
    && currentUserIsAdmin(state) && !targetItems[0].builtIn,
  isClickable: (_, targetItems) => !targetItems[0].builtIn,
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
    throw new Error('deleteLabelValue was called without exactly one item');
    }
    return deleteLabelValueAction(items[0]);
  }
};